import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateUtils } from '@app/utils/date';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import de from '@angular/common/locales/de';
import en from '@angular/common/locales/en';
import { StringMap } from '@app/utils/string-map';

const translations: StringMap<any> = {
  de,
  en,
};

@Injectable()
export class PortalNgbDatepickerI18n extends NgbDatepickerI18n {
  private datePipe: DatePipe;
  private locale: string;

  constructor(private translateService: TranslateService) {
    super();

    this.translateService.onLangChange.subscribe((event) => {
      this.locale = event.lang;

      this.createDatePipe(event.lang);
    });

    this.locale = translateService.currentLang;
    this.createDatePipe(this.locale);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const d: Date = DateUtils.parse(date);

    return this.datePipe.transform(d, 'EEEE');
  }

  getMonthFullName(month: number, year?: number): string {
    const d: Date = DateUtils.parse({
      day: 1,
      month,
      year,
    });

    return this.datePipe.transform(d, 'LLLL');
  }

  getMonthShortName(month: number, year?: number): string {
    const d: Date = DateUtils.parse({
      day: 1,
      month,
      year,
    });

    return this.datePipe.transform(d, 'LLL');
  }

  getWeekdayLabel(weekday: number): string {
    const translation = translations[this.locale];

    return translation[3][1][weekday % 7];
  }

  private createDatePipe(locale: string) {
    this.datePipe = new DatePipe(locale);
  }
}
